import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  LineController,
  ScatterController,
  BarElement,
  ArcElement,
  Title as ChartTitle,
  Tooltip,
  Legend,
} from "chart.js";
import { Chart } from "react-chartjs-2";
import { BoxPlotController, BoxAndWiskers } from '@sgratzl/chartjs-chart-boxplot';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  LineController,
  ScatterController,
  BarElement,
  ArcElement,
  ChartTitle,
  Tooltip,
  Legend,
  BoxPlotController, 
  BoxAndWiskers
);

export function DynamicChart ({ type = "bar", title = "", location = "", data = {}, options = {}, height = 300, width = "100%" }) {
  const defaultOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      title: {
        display: !!title,
        text: `${title} ${location ? `- ${location}` : ""}`,
        font: {
          size: 18,
        },
      },
      legend: {
        position: "top",
      },
    },
  };
  return (
    <div style={{ width, height }}>
      <Chart
        type={type}
        data={data}
        options={{ ...defaultOptions, ...options }}
      />
    </div>
  );
}
